import { arrayOf, node, bool, func } from "prop-types";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

const propTypes = {
  children: arrayOf(node).isRequired,
  handleTabSelect: func,
  selectFirstActive: bool,
};

const TabsComponent = (props) => {
  const { children, handleTabSelect, selectFirstActive } = props;

  return (
    <Tabs
      className="tabs container"
      defaultIndex={
        selectFirstActive && children.findIndex((item) => !item.props.disabled)
      }
      disabledTabClassName="tabs__tab--disabled"
      onSelect={
        typeof handleTabSelect === "function" &&
        ((index) => handleTabSelect(index))
      }
      selectedTabClassName="tabs__tab--selected"
    >
      <TabList className="tabs__list">
        {children &&
          children.map((item, index) => {
            const { disabled, label } = item.props;
            return (
              <Tab
                className="tabs__tab"
                disabled={disabled}
                key={index + label}
              >
                {label}
              </Tab>
            );
          })}
      </TabList>

      {children &&
        children.map((item, index) => (
          <TabPanel
            className="tabs__panel"
            key={index + "-content-" + item.label}
          >
            {item}
          </TabPanel>
        ))}
    </Tabs>
  );
};

TabsComponent.propTypes = propTypes;
export default TabsComponent;
